import { View, Text, hexColor } from "@lightningtv/solid";
import { createSignal, onMount, onCleanup } from "solid-js";
import PinKeyboardFast from "./PinKeyboardFast";
import Header from "./Header";
import { t } from "../translations/configuration";

export default function ConfirmPin(props: {
    onPinSet: (pin?: string) => void;
    showBackground?: boolean;
    showText?: boolean;
    x?: number;
    y?: number;
    title?: string;
}) {
    const keyboardRef: any = {};
    // ── keep exact same logic as old code ────────────────────────────────
    const showBackground = props.showBackground !== false;

    const [isEnterEnabled, setIsEnterEnabled] = createSignal(false);
    let enableTimeout: number | null = null;

    onMount(() => {
        console.log('ConfirmPin opened - Enter key disabled for 1 second');
        enableTimeout = setTimeout(() => {
            setIsEnterEnabled(true);
            console.log('Enter key input now enabled');
        }, 1000);
    });

    onCleanup(() => {
        if (enableTimeout) clearTimeout(enableTimeout);
    });

    const handlePinSubmit = (pin: string) => {
        if (!isEnterEnabled()) {
            console.log('Enter key input not yet enabled - ignoring submission');
            return;
        }
        const savedPin = localStorage.getItem("userPin");
        console.log('pin', pin);
        console.log('savedPin', savedPin);
        if (pin === savedPin) {
            props.onPinSet(pin);
        }
        keyboardRef.resetInput?.();
    };

    // ── Keyboard-only version — same wrapper as old code ─────────────────
    const KeyboardOnlyContent = () => (
        <View x={props.x || 0} y={props.y || 0}>
            <Text x={190} y={0} fontSize={36}>
                {props.title || t('enter_parental_pin')}
            </Text>
            <Text x={190} y={50} fontSize={24} color={"#fff"} />
            <PinKeyboardFast
                onSubmit={handlePinSubmit}
                keyboardRef={keyboardRef}
                isEnterEnabled={isEnterEnabled()}
                onEnterAttempt={() => {
                    console.log('Enter attempted too early - please wait');
                }}
            />
        </View>
    );

    // ── Full background version — same wrapper as old code ───────────────
    // Old code: <View color={"#182027"}> + <Header> + <View x={610} y={200}>
    // New code: same structure, just darker background color
    const FullScreenContent = () => (
        <View color={hexColor("#0d0f14")}>
            <Header screen={""} />

            <View x={610} y={200}>
                <KeyboardOnlyContent />
            </View>
        </View>
    );

    return showBackground ? <FullScreenContent /> : <KeyboardOnlyContent />;
}